<template>
<div class="training-courses__wrapper">
  <div class="training-courses" >
    <div class="overlay" v-show="showSelectedCourse" @click="showSelectedCourse = false" ></div>
    <div class="training-courses training-courses__course" :data-id="course.id" v-for="course in courses" :key="course.id">

      <div class="training-courses__image"
           :style="`background: url(${course.acf.intro_image.sizes.medium}) no-repeat center center / cover`" ></div>
      <!-- <img :src="course.acf.intro_image.sizes.medium" > -->

      <h3>{{ course.title.rendered }}</h3>

      <div class="training-courses training-courses__content" v-html="shorten(course.acf.intro_text)"></div>

      <a @click.prevent="selectCourse(course)" class="elementor-button-link elementor-button elementor-size-sm">See more</a>

      <div class="training-courses__course--marker" v-if="selectedCourse.id == course.id && showSelectedCourse"></div>


    </div> 

    </div>

    <div class="training-courses__popup dark_info_sec" :style="PopupStyle" v-if="showSelectedCourse">
      <span class="training-courses__popup--close" @click="showSelectedCourse = false" >&times;</span>
      <h2>{{ selectedCourse.title.rendered }} Course Details</h2>
      <div class="training-courses__popupcontentwrapper">
        <div class="image" :style="`background: url(${selectedCourse.acf.intro_image.sizes.medium_large}) no-repeat center center / cover`"></div>
        <div class="training-courses__popupcontent" >
          <div class="" v-html="selectedCourse.acf.intro_text"></div>
          <h3 v-if="selectedCourse.acf != undefines && selectedCourse.acf.training_modules">Training Modules</h3>
          <ul>
            <li v-for="(mod, index) in selectedCourse.acf.training_modules" :key="index">
              <strong>{{ mod.post_title }}</strong>
            </li>
          </ul>
          <p>
            <a href="/training-grounds-enquiry" class="elementor-button-link elementor-button elementor-size-sm button-white">Enquire Now</a>
          </p>
        </div>

      </div>
      
    </div>
 
    
</div>
  
</template>


<script>
  import axios from 'axios';
  import UtilService from '../services/util.service';

  export default {
    data: function () {
      return {
        pageType: "courses",
        courses: [], 
        chunkedCourses: [],
        showSelectedCourse: false,
        selectedCourse: {},
        post: {}
      };
    },
    props: ['type'],
    methods: {
      async sample() {
        const { data } = await axios.get(``);
      },
      async getAllCourses() { 
        const { data } = await axios.get(`/wp-json/wp/v2/training_courses?per_page=50`);
        this.courses = data;  
      },
      selectCourse(course) {
        if(course.id === this.selectedCourse.id) {
          this.showSelectedCourse = !this.showSelectedCourse;
        } else {
          this.showSelectedCourse = true;
        }
        this.selectedCourse = course; 
      },
      shorten(html) {
        var div = document.createElement("div");
        div.innerHTML = html;
        var text = div.textContent || div.innerText || "";

        return text.length > 160 ? `${text.substring(0, 160)}...` : text;
      }
  },  
    computed: {
      PopupStyle() {
        if(this.showSelectedCourse) {
          var element = jQuery(`.training-courses__course[data-id=${this.selectedCourse.id}]`);
          var offset = element.height() + element.position().top + 25;

          return `position: absolute; top: ${offset}px;`;
        }

        return "display: none;";
      }
    },
    async mounted() {
      this.pageType = this.type;
      await this.getAllCourses();
    }
  }

</script>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/TrainingCourses.vue